
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../directives/TranslatePipe';
import { FSTREAM_Image } from '../../../models/matwins-tenant/FSTREAM_Image.model';

@Component({
    selector: 'app-download-document',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    templateUrl: './download-document.component.html'
})
export class DownloadDocumentComponent {
    @Input() attachments: FSTREAM_Image[] | null | undefined = [];
    @Input() columns: number = 3;

}